/**
 * Get Resource Label based on the contentType
 * Currently uses only for Resource/Whitepaper articles
 *
 * @param {Object} article
 * @return {String}
 */
export const getResourceLabel = (article) => {
  if (article && article.contentType && article.contentType.toLowerCase() === 'whitepaper') {
    return article.contentType.toLowerCase();
  }

  return '';
};
